export default {
    LOGIN_PAGE: '/login',
    HOME_PAGE: '/',
    USER_ADD: '/user',
    USER_MANAGER: '/user/manage',
    USER_EDIT: '/user/:idUser',
    FIRST_CONNEXION_PAGE: '/login/key/:keypass',
    RESET_PASSWORD : '/login/reset',
    EDIT_MY_ACCOUNT : '/myaccount/edit',
    EDIT_MY_PASSWORD : '/password/edit',
    JOB_HISTORY: '/jobHistory',
    VERSION_PAGE: '/version',
    REPORTING_PERIODIC_PAGE: '/periodic',
    FINANCED_TRANSACTION_PAGE: '/transactions-financees',
    TRANSACTION_PAGE: '/transactions-acceptees',
    SHOP_PAGE: '/shop',
    INVOICE_PAGE: '/invoice'
};



// WEBPACK FOOTER //
// ./src/enums/PageEnum.js